var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcReward(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1236_4574",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 12,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 12,
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1236_4574)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.063 13.0012H16.938C16.2134 13.0012 15.6228 13.5973 15.6501 14.3192C15.6556 14.4641 15.661 14.609 15.6692 14.7512H12.7817C12.4181 14.7512 12.1255 15.0438 12.1255 15.4075C12.1255 17.9395 13.0415 19.7004 14.272 20.8954C15.4833 22.0739 16.9599 22.6672 18.0481 22.968C18.688 23.1458 19.1255 23.679 19.1255 24.2149C19.1255 24.7864 18.6606 25.2512 18.0892 25.2512H17.3755C16.8915 25.2512 16.5005 25.6422 16.5005 26.1262C16.5005 26.6102 16.8915 27.0012 17.3755 27.0012H22.6255C23.1095 27.0012 23.5005 26.6102 23.5005 26.1262C23.5005 25.6422 23.1095 25.2512 22.6255 25.2512H21.9118C21.3403 25.2512 20.8755 24.7864 20.8755 24.2149C20.8755 23.679 21.3103 23.143 21.9528 22.968C23.0438 22.6672 24.5204 22.0739 25.7317 20.8954C26.9595 19.7004 27.8755 17.9395 27.8755 15.4075C27.8755 15.0438 27.5829 14.7512 27.2192 14.7512H24.3317C24.3399 14.609 24.3454 14.4668 24.3509 14.3192C24.3782 13.5973 23.7876 13.0012 23.063 13.0012ZM13.4626 16.0637H15.7704C16.0192 18.5274 16.5688 20.1735 17.1896 21.2754C16.5087 20.9747 15.8005 20.5508 15.188 19.9547C14.313 19.1043 13.6021 17.8766 13.4653 16.0637H13.4626ZM24.8157 19.9547C24.2032 20.5508 23.495 20.9747 22.8142 21.2754C23.4349 20.1735 23.9845 18.5274 24.2333 16.0637H26.5411C26.4017 17.8766 25.6907 19.1043 24.8185 19.9547H24.8157Z",
    fill: "#6B7280"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcReward);
export default __webpack_public_path__ + "static/media/ic_reward.6b4592453bb7d68037ecbd77d7e89bf9.svg";
export { ForwardRef as ReactComponent };